import SLSDevolucaoClient from '@/api/Operacoes/sls-devolucao.client';

const client = new SLSDevolucaoClient();

export default {
  namespaced: true,
  state: () => ({
    isLoading: false,
    isSaving: false,
    devolucoes: [],
    devolucaoAtual: null,
    meta: {},
    filters: {},
  }),
  actions: {
    async listar({ commit, state }) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.listar({ ...state.filters });
        commit('SET_DEVOLUCOES', res.data || []);
        commit('SET_META', res.meta || {});
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async buscarPorId({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.buscarPorId(id);
        commit('SET_DEVOLUCAO_ATUAL', res.data || null);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async criar({ commit, dispatch }, payload) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.criar(payload);
        await dispatch('listar');
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async atualizarStatus({ commit, dispatch, state }, { id, status, observacao }) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.atualizarStatus(id, { status, observacao });
        commit('SET_DEVOLUCAO_ATUAL', res.data || null);
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters);
    },
    clearFilters({ commit }) {
      commit('CLEAR_FILTERS');
    },
  },
  mutations: {
    SET_LOADING(state, v)          { state.isLoading = v; },
    SET_SAVING(state, v)           { state.isSaving = v; },
    SET_DEVOLUCOES(state, v)       { state.devolucoes = v; },
    SET_DEVOLUCAO_ATUAL(state, v)  { state.devolucaoAtual = v; },
    SET_META(state, v)             { state.meta = v; },
    SET_FILTERS(state, filters) {
      const next = { ...state.filters };
      Object.entries(filters || {}).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') { delete next[k]; return; }
        next[k] = v;
      });
      state.filters = next;
    },
    CLEAR_FILTERS(state) { state.filters = {}; },
  },
  getters: {
    isLoading:       (s) => s.isLoading,
    isSaving:        (s) => s.isSaving,
    devolucoes:      (s) => s.devolucoes,
    devolucaoAtual:  (s) => s.devolucaoAtual,
    meta:            (s) => s.meta,
    filters:         (s) => s.filters,
  },
};
